exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".print{margin-top:20px;margin-right:20px}.print-container{display:flex;flex-direction:column;background-color:#e6eef0;justify-content:center}.print-section{display:flex;margin:20px 30px}.print-info{width:100%;display:flex;flex-direction:column;margin-top:20px;margin-bottom:20px;padding:10px}.print-links{display:flex;justify-content:flex-end}.print-links .preview-link{margin-right:20px}.print-section.compliance-disclaimer{padding-top:10px;font-size:smaller}.btn-toolbar{max-width:240px;margin:auto;text-align:end}.btn-toolbar .primary-button{margin-right:10px}", ""]);

// exports
